import { Box } from '@mui/material';
import BasicModal from 'components/Common/BasicModal';
import EditorWithFooter from 'components/Common/EditorWithFooter';
import { FC } from 'react';
import { FullScreenModalType } from '../types';

const FullScreenModal: FC<FullScreenModalType> = ({
    open,
    onClose,
    value,
    handleEditorChange,
    hasCancel,
    onSubmit,
    isEditable,
    onCancel,
    title,
    date,
    onOpenFullScreen,
}) => {
    return (
        <BasicModal open={open} onClose={onClose}>
            <Box className="fullScreen-job">
                <Box className="job-generator right-sidebar-editor">
                    <Box className="output-editor">
                        <EditorWithFooter
                            value={value}
                            handleEditorChange={handleEditorChange}
                            hasCancel={hasCancel}
                            onSubmit={onSubmit}
                            onCancel={onCancel}
                            date={date}
                            isEditable={isEditable}
                            title={title}
                            onCloseParentFullScreen={onClose}
                            onOpenFullScreen={onOpenFullScreen}
                            isFullScreen={open}
                        />
                    </Box>
                </Box>
            </Box>
        </BasicModal>
    );
};

export default FullScreenModal;
